import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { localStorageSet } from "../utils/LocalStorageHelper";
import { localizePath, normalizeLang } from "../utils/seoConfig";

export const ChangeLanguage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const languages = ["en", "de"];
  const currentLanguage = normalizeLang(i18n.language);

  return (
    <div className="dropdown-container">
      <button className="dropdown-button" onClick={() => setIsOpen(!isOpen)}>
        {t(currentLanguage)}
      </button>
      {isOpen && (
        <div className="dropdown-menu">
          {languages.map((e) => (
            <div
              key={e}
              className="dropdown-item"
              onClick={() => {
                localStorageSet("i18nextLng", e);
                i18n.changeLanguage(e);
                navigate(
                  localizePath(location.pathname, e) +
                    location.search +
                    location.hash
                );
                setIsOpen(false);
              }}
            >
              {t(e)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
